import FormErrors from "pages/ManagementPage/FormErrors/FormErrors";

export default FormErrors;
